import { render, staticRenderFns } from "./DetailedColourComponent.vue?vue&type=template&id=da7f1e96"
import script from "./DetailedColourComponent.vue?vue&type=script&lang=ts"
export * from "./DetailedColourComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports